<template>
  <v-container fluid class="border-top">
    <v-layout row wrap justify-space-between>
      <v-flex xs12>
        <s-textbox label="assessments_description" :text="assessment.description || 'assessments_null_value'"/>
      </v-flex>
      <v-flex xs12 sm6>
        <s-textbox v-if="assessment.assessmentUrl && assessment.assessmentUrls.length == 0" label="assessments_assessmentUrl"
                   :link="{url: assessment.assessmentUrl, urlKey: $t('assessments_url_link')}"/>
        <div v-else-if="assessment.assessmentUrls && assessment.assessmentUrls.length > 0 && urlCount(assessment.assessmentUrls, 'assessment')">
          <s-textbox class="margin-reduce" label="assessments_assessmentUrls" />
          <div v-for="link in assessment.assessmentUrls" :key="link.id" class="prevent-overflow align" style="overflow: hidden">
            <a target="_blank" v-if="link.urlType =='assessment'" v-bind:key="link.url" :href="link.url" :id="assessmentUrlId(link.id)">{{link.label}}</a>
          </div>
        </div>
        <s-textbox v-else label="assessments_assessmentUrl" :text="$t('assessments_null_value')"/>
      </v-flex>
      <v-flex xs12 sm6>
        <s-textbox label="assessments_submissionDate" :date="assessment.submissionDate || 'assessments_null_value'"/>
      </v-flex>
      <v-flex xs12 v-if="$vuetify.breakpoint.xsOnly">
        <s-textbox label="assessments_lastUpdated" :text="assessment.lastUpdated || 'assessments_null_value'"/>
      </v-flex>
      <v-flex xs12 sm6>
        <div v-if="assessment.tutorFeedback || (assessment.assessmentUrls && assessment.assessmentUrls.length > 0 && urlCount(assessment.assessmentUrls, 'tutor'))">
          <s-textbox class="margin-reduce" label="assessments_tutorFeedback" />
          <p v-html="assessment.tutorFeedback" class="prevent-overflow align margin-zero" style="overflow: hidden"></p>
          <div v-for="link in assessment.assessmentUrls" :key="link.id" class="prevent-overflow align" style="overflow: hidden">
            <a target="_blank" v-if="link.urlType =='tutor'" v-bind:key="link.url" :href="link.url" :id="tutorUrlId(link.id)">{{link.label}}</a>
          </div>
        </div>
        <s-textbox v-else label="assessments_tutorFeedback" :text="$t('assessments_null_value')"/>
      </v-flex>
      <v-flex xs12 sm6>
        <div v-if="assessment.studentComment">
        <s-textbox class="margin-reduce" label="assessments_studentComment" />
        <p v-html="assessment.studentComment" class="prevent-overflow align" style="overflow: hidden"></p>
        </div>
        <s-textbox v-else label="assessments_studentComment" :text="$t('assessments_null_value')"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import STextbox from '../intervention/studentProfileIntervention/STextbox'

  export default {
    components: {STextbox},
    name: 'student-assessments-body',
    props: ['assessment', 'open', 'reset'],
    mixins: [],
    data () {
      return {}
    },
    methods: {
      urlCount (assessmentUrls, comparisonString) {
        return assessmentUrls.filter(el => el.urlType === comparisonString)
      },
      tutorUrlId (id) {
        return 'tutor-assessment-url-' + id
      },
      assessmentUrlId (id) {
        return 'assessment-url-' + id
      }
    },
    computed: {
    },
    watch: {}
  }
</script>

<style scoped>
  .align {
    padding-left: 10px;
  }
  .margin-reduce {
    margin-bottom: -2px !important;
  }
  .margin-zero {
    margin-bottom: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/student/StudentAssessmentsBody.vue